module.exports = __webpack_public_path__ + "img/02.b3e5a86e.jpg";